import { useState, useEffect } from 'react';
import { fetchWithAuth } from './authHelpers';

export const useTeam = () => {
    const [teamNames, setTeamNames] = useState([]);
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [teamsLoading, setTeamsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [teamsError, setTeamsError] = useState(null);

    useEffect(() => {
        const fetchTeamNames = async () => {
            try {
                const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/teams/names`, 'GET');
                const data = await response.json();
                if (Array.isArray(data)) {
                    setTeamNames(data);
                } else {
                    console.error("Unexpected data format");
                }
            } catch (error) {
                setError(error);
                console.error("Error fetching team names");
            } finally {
                setLoading(false);
            }
        };

        fetchTeamNames();
    }, []);

    const fetchAllTeams = async () => {
        setTeamsLoading(true);
        setTeamsError(null);
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/teams`, 'GET');
            if (!response.ok) {
                throw new Error('Failed to fetch teams');
            }
            const data = await response.json();
            if (Array.isArray(data)) {
                setTeams(data);
            } else {
                console.error("Unexpected data format");
                throw new Error("Invalid data format received");
            }
        } catch (error) {
            setTeamsError(error.message);
            console.error("Error fetching teams");
        } finally {
            setTeamsLoading(false);
        }
    };

    return { 
        teamNames, 
        teams,
        loading, 
        teamsLoading,
        error,
        teamsError,
        fetchAllTeams
    };
};